import { Component } from '@angular/core';
import { HomeConfig } from 'src/app/model/homeConfig';
import { AppModeService } from 'src/app/services/app-mode.service';
import { HomeService } from './services/home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent {
  constructor(
    private readonly configService: HomeService,
    public readonly appModeService: AppModeService
  ) {}
  config!: HomeConfig;
  lang: string = localStorage.getItem('lang')!;
  files: any;
  sharedConfig: any;

  ngOnInit(): void {
    this.configService.getConfig('en').subscribe((enData) => {
      this.sharedConfig = {
        facebookUrl: enData.facebookUrl,
        xUrl: enData.xUrl,
        whatsappUrl: enData.whatsappUrl,
        instaUrl: enData.instaUrl,
        email: enData.email,
        heroVideoUrl: enData.heroVideoUrl!,
        bannerImageUrl: enData.bannerImageUrl!,
        catalogueSliderImageUrls: enData.catalogueSliderImageUrls.map(
          (url) => url
        ),
        cataloguePdfUrl: enData.cataloguePdfUrl!,
      };
      this.configService.getConfig(this.lang).subscribe((langData) => {
        this.config = { ...langData, ...this.sharedConfig, ...this.files };
      });
    });
  }
}
